import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { EXAM_STAGE_TAB } from '../constants/tabs'

interface IFUseScrollTabReturns {
  activeTab: string | null
}

const useScrollTab = (): IFUseScrollTabReturns => {
  const router = useRouter()
  const { query } = router
  const [activeTab, setActiveTab] = useState((query.tab as string) || null)

  useEffect(() => {
    window.document.documentElement.style.scrollBehavior = 'smooth'

    return () => {
      window.document.documentElement.style.scrollBehavior = 'unset'
    }
  }, [])

  useEffect(() => {
    const sectionOne = document?.querySelector('#section1')
    const sectionTwo = document?.querySelector('#section2')

    if (!sectionOne || !sectionTwo) return

    const observer = new IntersectionObserver(
      (entries) => {
        let hasIntersectingEntry = false

        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          hasIntersectingEntry = true

          const target = entry.target as HTMLElement

          if (target.id === 'section1') {
            setActiveTab(EXAM_STAGE_TAB.FULL_RESERVATION)
          }
          if (target.id === 'section2') {
            switch (query.tab) {
              case EXAM_STAGE_TAB.REAL_TIME_RESTORE:
                setActiveTab(EXAM_STAGE_TAB.REAL_TIME_RESTORE)
                break
              case EXAM_STAGE_TAB.EXAM_REVIEW:
                setActiveTab(EXAM_STAGE_TAB.EXAM_REVIEW)
                break
              case EXAM_STAGE_TAB.EXAM_VOTE:
                setActiveTab(EXAM_STAGE_TAB.EXAM_VOTE)
                break
              case EXAM_STAGE_TAB.PREDICTION_SCORE:
                setActiveTab(EXAM_STAGE_TAB.PREDICTION_SCORE)
                break
              default:
                setActiveTab(EXAM_STAGE_TAB.REAL_TIME_RESTORE)
                break
            }
          }
        })

        if (!hasIntersectingEntry) {
          setActiveTab(null)
        }
      },
      { rootMargin: '0px 0px 0px 0px', threshold: [0.1] },
    )

    observer.observe(sectionOne)
    observer.observe(sectionTwo)

    return () => {
      observer.disconnect()
    }
  }, [query.tab])

  return { activeTab }
}

export default useScrollTab
